var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentTextOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4C8.46957 4 7.96086 4.21071 7.58579 4.58579C7.21071 4.96086 7 5.46957 7 6V26C7 26.5304 7.21071 27.0391 7.58579 27.4142C7.96086 27.7893 8.46957 28 9 28H23C23.5304 28 24.0391 27.7893 24.4142 27.4142C24.7893 27.0391 25 26.5304 25 26V13.8283C25 13.8282 25 13.8282 25 13.8281C24.9999 13.5631 24.8946 13.3089 24.7073 13.1215C24.7072 13.1215 24.7072 13.1214 24.7072 13.1214L15.8786 4.29281C15.6911 4.1054 15.4369 4.00008 15.1719 4C15.1718 4 15.1718 4 15.1717 4H9ZM6.17157 3.17157C6.92172 2.42143 7.93913 2 9 2H15.172C15.9674 2.00012 16.7302 2.31609 17.2927 2.87844L17.2927 2.87852L26.1216 11.7073C26.6839 12.2698 26.9999 13.0326 27 13.828V26C27 27.0609 26.5786 28.0783 25.8284 28.8284C25.0783 29.5786 24.0609 30 23 30H9C7.93913 30 6.92172 29.5786 6.17157 28.8284C5.42143 28.0783 5 27.0609 5 26V6C5 4.93913 5.42143 3.92172 6.17157 3.17157Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.5C16.5523 2.5 17 2.94772 17 3.5V11C17 11.2652 17.1054 11.5196 17.2929 11.7071C17.4804 11.8946 17.7348 12 18 12H25.5C26.0523 12 26.5 12.4477 26.5 13C26.5 13.5523 26.0523 14 25.5 14H18C17.2043 14 16.4413 13.6839 15.8787 13.1213C15.3161 12.5587 15 11.7957 15 11V3.5C15 2.94772 15.4477 2.5 16 2.5ZM10 18C10 17.4477 10.4477 17 11 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H11C10.4477 19 10 18.5523 10 18ZM10 23C10 22.4477 10.4477 22 11 22H21C21.5523 22 22 22.4477 22 23C22 23.5523 21.5523 24 21 24H11C10.4477 24 10 23.5523 10 23Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentTextOutline);
export default __webpack_public_path__ + "static/media/document-text-outline.5c6283532137899234f8179c99f0b9d6.svg";
export { ForwardRef as ReactComponent };